import React from "react";
import Newsletter_40 from "../component/Newsletter_40";

function Newsletter_40Container() {
  return <Newsletter_40 />;
}

export default Newsletter_40Container;
